import React from 'react';

interface IProps {
  fillColor?: string;
}

export const ArrowRightIcon:React.FC<IProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="1 0 24 24">
      <path fill={props.fillColor ? props.fillColor : "#fff"} d="M10.6 16.6l4.6-4.6-4.6-4.6L12 6l6 6-6 6-1.4-1.4z"/>
    </svg>
  )
}